var _excluded = ["children", "className", "tag", "type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
import "../../../../enums/accordion.js";
import { AlertTypes } from "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseAlert = function BaseAlert(props) {
  var children = props.children,
    className = props.className,
    _props$tag = props.tag,
    tag = _props$tag === void 0 ? 'div' : _props$tag,
    _props$type = props.type,
    type = _props$type === void 0 ? AlertTypes.Assertive : _props$type,
    otherProps = _objectWithoutProperties(props, _excluded);
  /**
  * Polite means the alert can wait until the screen reader user is finished with their current task
  * and not doing anything (such as stopped typing). A good example is search results count being spoken
  * after a user stops typing into a type="search" input and data is returned from a server.
  *
  * Assertive means the alert text should be spoken by a screen reader as soon as possible.
  * This should be reserved for UI elements like error messages, form validation messages,
  * and other situations where interruption is imperative.
  *
  * Our alerts have role="alert", which is shorthand for aria-live="assertive" with aria-atomic="true".
  * Adding `AlertTypes.Polite` (aria-live="polite") will delay announcing the alert text as described above.
  *
  * https://www.w3.org/TR/wai-aria-practices-1.2/#alert
  *
  * https://www.w3.org/TR/wai-aria/#aria-live
  *
  * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-live
  *
  * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-atomic
  *
  * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/alert_role
  */
  var getType = function getType() {
    switch (type) {
      case AlertTypes.Polite:
        {
          return {
            'aria-live': 'polite'
          };
        }
      default:
        {
          return {};
        }
    }
  };
  var Tag = tag;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, otherProps, getType(), {
    className: classnames('bf-alert', className),
    role: "alert"
  }), children);
};
export { BaseAlert };